import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3841567b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tour-list-selected" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "ツアー参加日一覧", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "ツアー参加日のご入力ありがとうございます", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert" }, [
  /*#__PURE__*/_createTextVNode(" TOUR参加当日に問診票のご入力を"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" お願いいたします ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-horizontal" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-horizontal" }, null, -1))
const _hoisted_7 = { class: "container-buttons" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 参加日を修正する ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderWithCloseButton = _resolveComponent("TheHeaderWithCloseButton")!
  const _component_TourListSelectedSectionTourDate = _resolveComponent("TourListSelectedSectionTourDate")!
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeaderWithCloseButton, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("main", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tourOptionsComputed, (tour) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tour.tourId
        }, [
          _createVNode(_component_TourListSelectedSectionTourDate, {
            tour: tour,
            active: tour.isToday,
            onButton: _ctx.navigateToQuestionnaire
          }, null, 8, ["tour", "active", "onButton"]),
          _hoisted_6
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppButtonPrimary, {
          class: "primary",
          "show-caret": false,
          onButton: _ctx.navigateToTourSelect
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onButton"]),
        _createVNode(_component_AppButtonSecondary, {
          class: "secondary",
          onButton: _ctx.close
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onButton"])
      ])
    ])
  ]))
}